import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

import PopupButton from "@components/Static/Popup/PopupButton";
import Checkbox from "@assets/icons/Checkbox";

const NavPopupButton = ({
  Icon,
  label,
  path,
  onClick,
  textClassName,
  text,
  isSelected,
  className,
  unreadMessage,
  countBadge,
  labelColor = "",
  guideTarget,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onRedirect = () => {
    if (path) {
      navigate(path);
    }

    if (typeof onClick === "function") {
      onClick();
    }
  };

  return (
    <PopupButton
      guideTarget={guideTarget}
      className={clsx("flex w-full flex-row justify-between my-1", className)}
      onClick={onRedirect}
    >
      <div className="flex flex-row items-center">
        {Icon && (
          <div className="w-6 flex justify-center items-center">
            <Icon />
          </div>
        )}
        <div
          style={{ color: labelColor }}
          className={clsx(
            "text-m text-dawn-gray relative",
            Icon ? "ml-3" : "",
            textClassName
          )}
        >
          {text || t(label)}
          {unreadMessage ? (
            <>
              <div className="absolute inline-flex w-5 h-5 text-xs font-bold -right-6 bg-primary rounded-full -top-2 items-center justify-center">
                <span className="text-white font-light-poppins font-black">
                  {unreadMessage}
                </span>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
        {countBadge ? (
          <div className="ml-2 inline-flex w-5 h-5 shrink-0 text-xs font-bold bg-primary rounded-full items-center justify-center">
            <span className="text-white font-light-poppins font-black">
              {countBadge}
            </span>
          </div>
        ) : null}
      </div>
      {isSelected && <Checkbox size="h-6 w-6" />}
    </PopupButton>
  );
};

export default NavPopupButton;
